import React from "react";
import { useEffect, useState } from "react";
import {
  Box,
  Divider,
  Flex,
  FormLabel,
  Heading,
  Text,
} from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { Field, useFormikContext } from "formik";

import { Input, Checkbox, Textarea } from "../../components/FormElements";
import Select from "react-select";
import { getSchools } from "../../features/school/schoolSlice";
import { getGender } from "../../features/gender/genderSlice";

const StudentFieldSet = ({
  locationId,
  onSelectedSchoolChange,
  onSelectedGenderChange,
  selectedSchool,
  selectedGender,
  formik,
}) => {
  const { schools } = useSelector((state) => state.school || {});
  const { gender } = useSelector ((state) => state.gender || {});
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [selectedSchoolValue, setSelectedSchoolValue] = useState(null);
const [selectedGenderValue, setSelectedGenderValue] = useState(null);

  const { setFieldValue } = useFormikContext();
  let validationError = formik;

  useEffect(() => {
    if (!locationId) {
      return;
    }
    dispatch(getSchools(locationId))
      .then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          if (selectedSchool) {
            const selectedSchool_edit = response.payload.find(
              (school) => school.school_id === selectedSchool
            );

            const selectedOption = {
              value: selectedSchool_edit.school_id,
              label: selectedSchool_edit.school_name,
            };
            setSelectedSchoolValue(selectedOption);
            setFieldValue('school', selectedOption);
          }
          return response;
        } else {
          throw response.payload;
        }
      })
      .catch((error) => {
        console.error("getSchools dispatch error ", error);
      });
  }, [dispatch, locationId]);

    useEffect(() => {
    dispatch(getGender())
      .then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          if (selectedGender) {
            const selectedGender_edit = response.payload.find(
              (gender) => gender.gender_id === selectedGender
            );

            const selectedGenderOption = {
              value: selectedGender_edit.gender_id,
              label: selectedGender_edit.gender_name,
            };
            setSelectedGenderValue(selectedGenderOption);
            setFieldValue('gender', selectedGenderOption);
          }
          return response;
        } else {
          throw response.payload;
        }
      })
      .catch((error) => {
        console.error("getGender dispatch error ", error);
      });
  }, [dispatch]);

  const handleSelectSchoolChange = (selectedOption) => {
    setSelectedSchoolValue(selectedOption);
    onSelectedSchoolChange(selectedOption?.value);
    setFieldValue('school', selectedOption);
  };


   const handleSelectGenderChange = (selectedGenderOption) => {
    setSelectedGenderValue(selectedGenderOption);
    onSelectedGenderChange(selectedGenderOption.value);
    setFieldValue('gender', selectedGenderOption);
  };

  if (schools) {
    return (
      <React.Fragment>
        <Input
          name="studentEmail"
          label="Student Email address*"
          placeholder="Enter email"
          type="email"
        />
        <Input
          name="studentName"
          label="Student Full Name*"
          placeholder="Enter Full Name"
          type="text"
        />
        {validationError && validationError.errors.school ? (
          <div style={{ color: "red", textAlign: "end" }}>
            {validationError.errors.school}
          </div>
        ) : null}
        <Flex justifyContent="center">
          <FormLabel flexGrow={1} fontSize="0.9em">
            Select School*
          </FormLabel>
          <Box flexGrow={1} maxWidth="50%">
            <Select
              id="school_id"
              placeholder="Select School"
              isClearable
              options={schools.map((school) => ({
                value: school.school_id,
                label: school.school_name,
              }))}
              value={selectedSchoolValue}
              name="school"
              onChange={handleSelectSchoolChange}
              isSearchable
            />
          </Box>
        </Flex>
        <Flex justifyContent="center" mt="2">
          <FormLabel flexGrow={1} fontSize="0.9em">
            Select Gender*
          </FormLabel>
          <Box flexGrow={1} maxWidth="50%">
            <Select
              id="gender_id"
              placeholder="Select Gender"
              isClearable
             options={gender.map((gender) => ({
                value: gender.gender_id,
                label: gender.gender_name,
              }))}
              value={selectedGenderValue}
              name="gender"
              onChange={handleSelectGenderChange}
              isSearchable
            />
          </Box>
        </Flex>
        <Text fontSize="sm" mt="2em" color="red.800">
          *Please ensure that the name of the school you attend is included in
          the application, as failure to do so may result in the application
          being rejected.
        </Text>
        <Divider mt="3em" mb="2em" />
        <Heading as="h2" size="sm" textAlign="center" color="red.800" mb="1em">
          The following part should be completed by the Parent or Guardian only
        </Heading>
        {validationError && validationError.errors.isConsentGranted ? (
          <div style={{ color: "red" }}>
            {validationError.errors.isConsentGranted}
          </div>
        ) : null}
        <Checkbox
          name="isConsentGranted"
          helperMessage="*If the parent doesn't give consent Arup will not progress with the booking"
        >
          As a parent or guardian of this student, I grant consent* for this
          student to attend the Arup Transition Year Programme, and that Arup
          can use both the student and guardian email address for the TY
          Programme. The Arup TY Programme coordinators can use this email
          address directly for the purpose of the TY Programme via their
          @arup.com email addresses.
        </Checkbox>

        <br />
        <Input
          name="guardian_email_address"
          label="Guardian's Email for Confirmation*"
          placeholder="Enter email for Guardian"
          type="email"
        />
        <Input
          name="guardianName"
          label="Guardian's Full Name*"
          placeholder="Enter Guardian's full name"
          type="text"
        />
        <Input
          name="iceContactNumber"
          label="Emergency Contact Number*"
          placeholder="Enter Emergency Contact Number (Mobile Number)"
          type="text"
        />

        <Input
          name="altIceContactNumber"
          label="Alt. Emergency Contact Number"
          placeholder="Enter Alternative Emergency Contact Number"
          type="text"
          helperMessage="* Enter Alternative Emergency Contact Number, if different from above (Mobile Number)"
        />
        <Checkbox
          name="isAllowedLDL"
          helperMessage="*Has the student the guardian's permission to leave the office during lunch"
        >
          Permission to leave the Arup office during lunch hour (1pm-2pm)*
        </Checkbox>

        <br />
        <Checkbox
          name="isAllowedPB"
          helperMessage="*approve/ do not approve of photos taken during the TY Programme and published on our Arup social media.
          In line with the child protection laws we will not publish any students names with the photos.
          "
        >
          Permission to publish the photos on Arup social media taken during the
          TY Programme*
        </Checkbox>

        <br />
        <Textarea
          name="medicalConditions"
          label="Medical Conditions"
          placeholder="Enter any medical conditions"
          maxLength="1000"
        />
        <Textarea
          name="tyInfoSource"
          label="How did you hear about Arup TY Programme?"
          placeholder="..."
          maxLength="1000"
        />
        <Textarea
          name="questions"
          label="If you have any queries, you can list them below or contact us at Typrogramme@arup.com"
          placeholder="..."
          maxLength="1000"
        />
        {user.role && (
          <Textarea
            name="notes"
            label="Notes for student added by Admin User"
            placeholder="..."
            maxLength="1000"
          />
        )}
      </React.Fragment>
    );
  }
  return <></>;
};

export default StudentFieldSet;
